import { render, staticRenderFns } from "./user-admin-display.vue?vue&type=template&id=69894b4b&"
import script from "./user-admin-display.vue?vue&type=script&lang=js&"
export * from "./user-admin-display.vue?vue&type=script&lang=js&"
import style0 from "./user-admin-display.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports